export default __webpack_public_path__ + "static/media/Baleno.3503f863.png";